export enum AgentCategoryEnum {
  Analyser = "Analyser",
  Generation = "Generation",
  Validation = "Validation",
  Database = "Database",
  Misc = "Miscellaneous",
}
